import HealthLevels from './HealthLevels';
import HealthLevelLabels from './HealthLevelLabels';

const { NA, GO, SLOW, WHOA } = HealthLevels;

export default [
  { label: HealthLevelLabels[NA], value: NA },
  { label: HealthLevelLabels[GO], value: GO },
  { label: HealthLevelLabels[SLOW], value: SLOW },
  { label: HealthLevelLabels[WHOA], value: WHOA }
];
